import React from 'react'

function ConfigurationLayout({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex w-full min-w-0 max-w-full flex-col gap-10 py-1 px-8 sm:py-4  2xl:px-56">
            {children}
        </div>
    )
}

export default ConfigurationLayout